<button class="m-5 btn btn-lg btn-danger" (click)="onClick()">Click to initialize the Dev Team!</button>
